module.exports = __webpack_public_path__ + "img/057-box.31a8a4ca.svg";